/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-04-27 11:12:04
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-04-27 14:09:21
 */
import xss from 'xss';
import qs from 'qs';

import { storeSet, storeGet, storeRemove } from './localStorage';
import { getQueryString } from './baseTool';
/*
 * token相关操作
 * */

const TokenKey = 'Admin-Token';

export function getToken() {
  return storeGet(TokenKey);
}

export function setToken(token: any) {
  return storeSet(TokenKey, token);
}

export function removeToken() {
  return storeRemove(TokenKey);
}

const jump = (url: string) => {
  window.location.replace(xss(url));
};

/**
 * 跳登录
 */
export function jumpLogin(didloginUrl: string) {
  try {
    const { href } = window.location || {};

    // const jumpUrl = didloginUrl.replace(/state=[\s\S]*/gi, `state=${encodeURIComponent(href.replace(origin, ''))}`);

    const pathList = href.split('/#/');

    // 因为did帮decode了一次，导致state中遇到&时getQueryString会自动截断，所以这里encode两次，抵消did的第一次decode
    const jumpUrl = didloginUrl.replace(
      /state=[\s\S]*/gi,
      `state=${encodeURIComponent(encodeURIComponent(pathList[1])) || ''}`
    );

    window.location.href = xss(jumpUrl);
  } catch (e) {
    console.log(e);
    window.location.href = xss(didloginUrl);
  }
}

const parseQueryParams = (url: string) => {
  const query = url.split('?')[1];
  const queryObject = {};
  // const pattern = /([^&=]+)=([^&]*)/g;
  const pattern = new RegExp('([^&=]+)=([^&]*)', 'g');
  let match;
  while ((match = pattern.exec(query))) {
    if (!['code', 'token', 'state', 'v'].includes(decodeURIComponent(match[1]))) {
      queryObject[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
    }
  }
  return queryObject;
};

/**
 * 登录回跳
 */
export function jumpBackByLogin() {
  const path = qs.stringify(parseQueryParams(location.search));

  const state: any = decodeURIComponent(getQueryString('state') || '');
  const v: any = getQueryString('v');
  let redirectUrl = `${location.origin + v && v != null ? `?v=${v}` : ''}/#/`;

  if (state !== 'undefined' && state !== '?') {
    redirectUrl += state;
  }

  if (path) {
    redirectUrl += '?' + path;
  }

  jump(redirectUrl);
}
